import Image from 'next/image';
import topupdated from '../../../../public/topupatednew.webp';
import clutch from '../../../../public/clutupdatednew.webp';
import batch from '../../../../public/credit_batch.webp';

export default function ImageSection() {
  return (
    <>
      <div className="flex flex-col gap-y-2 justify-center items-center">
        <div>
          <Image
            src={batch}
            className="img-fluid"
            alt="Reward Batch"
            title="Reward Batch"
            sizes="100vw"
            style={{
              width: '35px',
              height: 'auto',
            }}
          />
        </div>
        <div className="flex flex-row gap-4">
          <Image
            src={clutch}
            className="img-fluid"
            alt="Clutch"
            title="Clutch"
            sizes="100vw"
            style={{
              width: '130px',
              height: 'auto',
            }}
          />
          <Image
            src={topupdated}
            className="img-fluid"
            alt="Top Market Research Agency"
            title="Top Market Research Agency"
            sizes="100vw"
            style={{
              width: '130px',
              height: 'auto',
            }}
          />
        </div>
      </div>
    </>
  );
}
